import * as API from '../utility/api'
import { I18n } from 'react-redux-i18n'
import { changeStep, steps } from './ticket-sale-steps'
import {
  START_VALIDATION_FETCH,
  ADD_TICKET_TO_SELL,
  SET_EVENT_INFO,
  DELETE_TICKET,
  TICKET_CODE_AUTH_FAILURE,
  TICKET_CODE_FOUND_SUCCESS,
  TICKET_CODE_NOT_FOUND_FAILURE,
  TICKET_CODE_CHANGED,
  TICKET_CODE_IS_INVALID
} from '../actionTypes'

export const checkTicket = ticketCode => {
  return dispatch => {
    dispatch({
      type: START_VALIDATION_FETCH
    })

    // Ticketcode must be url encoded because it may contain special characters
    // like # and %
    ticketCode = encodeURIComponent(ticketCode)
    API.GET('tickets/validate/' + ticketCode)
      .then(resp => {
        dispatch(ticketCodeFoundSuccess(resp.data))
      })
      .catch(e => {
        if (API.isHandledAuthError(e)) {
          dispatch(ticketCodeAuthFailure())
          return
        }

        const error =
          e && e.response && e.response.data && e.response.data.message
        dispatch(ticketCodeNotFoundFailure(error))
      })
  }
}

export const addTicketToSell = () => {
  return dispatch => {
    dispatch({
      type: ADD_TICKET_TO_SELL
    })
  }
}

export const fetchEventInfo = eventID => {
  return dispatch => {
    API.GET('events/' + eventID).then(resp => {
      dispatch({
        type: SET_EVENT_INFO,
        eventInfo: resp.data.event
      })
    })
  }
}

export const setEventInfo = eventInfo => {
  return dispatch => {
    dispatch({
      type: SET_EVENT_INFO,
      eventInfo: eventInfo
    })
  }
}

export const deleteTicket = ticketCode => {
  return (dispatch, getState) => {
    dispatch({
      type: DELETE_TICKET,
      ticketCode
    })
    if (getState().tickets.inSell.length < 1) {
      dispatch(changeStep(steps.codeInput))
    }
  }
}

const ticketCodeFoundSuccess = body => {
  return {
    type: TICKET_CODE_FOUND_SUCCESS,
    body
  }
}

const ticketCodeAuthFailure = () => {
  return {
    type: TICKET_CODE_AUTH_FAILURE,
    title: I18n.t('registration.invalid_login'),
    message: I18n.t('sell_page.session_expired_message')
  }
}

const ticketCodeNotFoundFailure = message => {
  return {
    type: TICKET_CODE_NOT_FOUND_FAILURE,
    message
  }
}

export const ticketCodeChanged = ticketCode => {
  return dispatch => {
    const sanitizedTicketCode = ticketCode.trim()

    dispatch({
      type: TICKET_CODE_CHANGED,
      ticketCode
    })

    if (checkTicketCodeValidity(sanitizedTicketCode)) {
      dispatch(checkTicket(sanitizedTicketCode))
    } else {
      dispatch({
        type: TICKET_CODE_IS_INVALID
      })
    }
  }
}

const checkTicketCodeValidity = ticketCode => {
  //test for 13 numbers or 14-20 alphanumeric characters including - and #
  return (
    /^[0-9]{13}$/.test(ticketCode) ||                 // exactly 13 digits
    /^[A-Za-z0-9\-#]{14,20}$/.test(ticketCode)        // 14–20 with letters/numbers/-/#
  );
}
